import { useEffect, useRef, useState } from "react";
import { useQuery } from "react-apollo";
import nanoid from "nanoid";

import { useStore } from "../providers/AppProvider";

import { GET_SOIL_DATA_SOURCES} from "../../../queries";

import { GetProperties_syncarto_dw_property } from "../../../__generated__/types";
import { DataSourceRasterLayer } from "../types/types";
import { getTileUrlTemplate } from "../utils/dataSourceUtils";

import { SETTING_SEASON_YEAR } from "../utils/settings";

export const useSoilHorizonDataSources = (horizonSelected:string | null) => {
    const {settings, orgId} = useStore();

    const [dataSources, setDataSources] = useState<DataSourceRasterLayer[]>([]);
    //console.log("012623 orgId", orgId)
    //console.log("122023 horizonSelected", horizonSelected)
    const {data, error, loading} = useQuery(GET_SOIL_DATA_SOURCES, {
        variables: {org_id: orgId},
        fetchPolicy: 'no-cache',
        //fetchPolicy: 'cache-and-network',
        //fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        onCompleted: (data) => {
            console.log("012623 onCompleted > data", data)
        }
    })

    const tsRef = useRef<string | null>(null);

    useEffect(() => {
        console.log("110822 settings[SETTING_SEASON_YEAR]", settings[SETTING_SEASON_YEAR]);
        console.log("110822 SETTING_SEASON_YEAR", SETTING_SEASON_YEAR);
    }, [settings[SETTING_SEASON_YEAR]]);

    useEffect(() => {
        console.log("012623 useEffect > data", data);
    }, [data]);

    useEffect(() => {
        console.log("012623 useEffect >  error",  error);
    }, [error]);

    useEffect(() => {
        console.log("012623 useEffect > loading, data", loading, data)
        if(!loading && data) { 
            console.log("012623 data > data", data)
            let settingsTs = null;
            if('indices_date' in settings) {
                const obj = JSON.parse(settings['indices_date']);
                settingsTs = obj.end_date;
            }

            if(tsRef.current !== settingsTs) {
                tsRef.current = settingsTs;
            } else {
                if(dataSources.length) {
                    return;
                }
            }

            // 
            const sources = data.syncarto_dw_property
            console.log("012623 useSoilHorizonDataSources > sources", sources);
            const sourcesFiltered = sources.filter((ds: any) => {
                return ds.data_source !== null;
            });
            console.log("012623 useSoilHorizonDataSources > sourcesFiltered", sourcesFiltered);
            const layers: DataSourceRasterLayer[] = sourcesFiltered.map((sourceParent: any) => {
                if (sourceParent.data_source){
                    /*console.log("X110822 sourceParent ---------------", sourceParent);
                    console.log("110822 tsRef", tsRef);
                    console.log("110822 horizonSelected", horizonSelected);
                    console.log("110822 settings[SETTING_SEASON_YEAR]", settings[SETTING_SEASON_YEAR]);
                    console.log("110822 SETTING_SEASON_YEAR", SETTING_SEASON_YEAR);*/
                    let source = sourceParent.data_source;
                    const dataSourceLayer: DataSourceRasterLayer = {
                        name: source?.name ?? source.title,
                        id: source.collection_id!,
                        uuid: nanoid(8),
                        min_zoom: source?.minZoom!,
                        max_zoom: source?.maxZoom!,
                        is_visible: source?.visible!,
                        type: source?.type!,
                        order: source?.order!,
                        tiles: getTileUrlTemplate(
                            source,
                            source.stac_address!, 
                            source.collection_id!,
                            'footprint_id',
                            `${settings[SETTING_SEASON_YEAR]}-01-01`, //source.min_date,
                            `${settings[SETTING_SEASON_YEAR]}-12-31`, //tsRef.current ? tsRef.current : source.max_date,
                            source.date_display_resolution!,
                            "template-seasonrange",
                            horizonSelected,
                        ),
                        unit: sourceParent.unit,
                        source: {...source},
                        property_id: sourceParent.id
                    };

                    return dataSourceLayer;
                 }
            });
            console.log("012623 useSoilHorizonDataSources > layers", layers);
            setDataSources(layers);
        }
    }, [loading, settings, horizonSelected, data/*, settings[SETTING_SEASON_YEAR]*/]);
    //console.log("012524 dataSources", dataSources);
    return { dataSources, loading };
}